import React from 'react';
import { Flex } from '@finect/tabular-core/Flex';
import { Spinner } from './../Spinner';
export var Loading = function Loading() {
  return React.createElement(Flex, {
    style: {
      height: '400px'
    },
    justify: "center",
    align: "center"
  }, React.createElement(Spinner, null));
};
export var NoData = function NoData(_ref) {
  var _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'No hay datos disponibles' : _ref$message;
  return React.createElement(Flex, {
    style: {
      height: '400px'
    },
    justify: "center",
    align: "center"
  }, React.createElement("div", null, message));
};